import { gql } from '@apollo/client'

export const GET_BLOG_LIST = gql`
    query MpBlogPosts($pageSize: Int!, $currentPage: Int!, $action: String!, $postId: Int, $storeId: String!, $categoryId: Int) {
        mpBlogPosts(action: $action, pageSize: $pageSize, currentPage: $currentPage, postId: $postId, filter: { store_ids: {eq: $storeId} }, categoryId: $categoryId, sortBy: "Latest") {
            total_count
            pageInfo {
                currentPage
                endPage
                hasNextPage
                hasPreviousPage
                pageSize
                startPage
            }
            items {
                allow_comment
                author_id
                author_name
                author_url
                author_url_key
                created_at
                enabled
                image
                import_source
                in_rss
                layout
                meta_description
                meta_keywords
                meta_robots
                meta_title
                name
                post_content
                post_id
                publish_date
                short_description
                store_ids
                updated_at
                url_key
                categories {
                    items {
                        category_id
                        name
                    }
                }
                view_traffic
            }
        }
    }
`
